import axios from 'axios';

export const HTTP = axios.create({
  baseURL: Slidestack.api_url
});

export const WEBCALL = axios.create({
  baseURL: Slidestack.base_url
});